import {
   FULFILL_TELEGRAM_SIGNALS
} from '../constants'
import {ClearState} from '../actions/commonActions'
import {
  FulfillTelegramSignals
} from '../actions/signalsActions'
import {TelegramSignal, TelegramSignalsResponse} from "../types";

export type TelegramSignalsState = TelegramSignalsResponse
const defaultState : TelegramSignalsState= {
  signals: [],
  clientStatistics: {
    usedSignals: 0,
    availableSignals: 0
  }
}
export function telegramSignals(
  state: TelegramSignalsState = defaultState,
  action: FulfillTelegramSignals | ClearState
): TelegramSignalsState {
  switch (action.type) {
    case FULFILL_TELEGRAM_SIGNALS:
      return {
        signals: action.signals.signals,
        clientStatistics: action.signals.clientStatistics
      }
    default:
      return state
  }
}
